import { createContext, Dispatch, FC, PropsWithChildren, SetStateAction, useState } from 'react';

import { CrmAccountWithRole, Impersonation } from '@types-be/next-auth';

export interface AccountsContextProps {
  selectedAccount: CrmAccountWithRole;
  accounts: CrmAccountWithRole[];
  setSelectedAccount: Dispatch<SetStateAction<CrmAccountWithRole>>;
  setAccounts: Dispatch<SetStateAction<CrmAccountWithRole[]>>;
  impersonation: Impersonation;
}

export const AccountsContext = createContext<AccountsContextProps>({
  selectedAccount: {
    alias: '',
    crmAccountNumber: '',
    role: 'owner',
  },
  accounts: [],
  setSelectedAccount: () => undefined,
  setAccounts: () => undefined,
  impersonation: {
    actsAsIdentityProviderDisplayName: '',
    actsAsIdentityProviderId: '',
    impersonatorSubject: '',
    accounts: [],
    type: 'None',
    role: 'reader',
  },
});

interface AccountsProviderProps extends PropsWithChildren {
  selectedAccount: CrmAccountWithRole;
  accounts: CrmAccountWithRole[];
  impersonation: Impersonation;
}

export const AccountsProvider: FC<AccountsProviderProps> = ({
  children,
  selectedAccount: selectedAccountDefault,
  accounts: accountsDefault,
  impersonation,
}) => {
  const [selectedAccount, setSelectedAccount] = useState<CrmAccountWithRole>(selectedAccountDefault);
  const [accounts, setAccounts] = useState<CrmAccountWithRole[]>(accountsDefault);

  return (
    <AccountsContext.Provider value={{ selectedAccount, accounts, setSelectedAccount, setAccounts, impersonation }}>
      {children}
    </AccountsContext.Provider>
  );
};
